import React, { useState, useEffect } from 'react';

const CollapsibleSection = ({ title, headerRight, children, expand = true }) => {
	const [isExpanded, setIsExpanded] = useState(!!expand);

	useEffect(() => {
		setIsExpanded(!!expand);
	}, [expand]);

	const toggleExpansion = () => {
		setIsExpanded(isExpanded => !isExpanded);
	};

	return (
		<section className={`collapsibleSection${isExpanded ? ' show' : ''}`}>
			<div className="collapsibleSectionHeader">
				<h2 onClick={toggleExpansion}>
					<span></span>
					{title}
				</h2>
				{headerRight}
			</div>
			<div className="collapsibleSectionContentWrapper">
				<div className="collapsibleSectionContent">{children}</div>
			</div>
		</section>
	);
};

export default CollapsibleSection;



// WEBPACK FOOTER //
// ./src/App/components/common/collapsibleSection.jsx